<xm-problem-widget-view
  [items]="problemItems()"
  [title]="'Problem Listing'"
  [searchFn]="searchProblems$"
  [canAdd]="canAdd()"
  [canDelete]="canDelete()"
  [isProcessing]="isProcessing()"
  [usePrimaryText]="settings?.themeWidgetText"
  (itemAdded)="onItemAdded($event)"
  (itemRemoved)="onItemRemoved($event)"
  (addNewItem)="onAddNewItem($event)">
</xm-problem-widget-view>
